import { useCallback, useContext, useMemo } from "react";
import useSWR, { SWRConfiguration, SWRResponse } from "swr";
import { IReturn, JsonServiceClient, appendQueryString, nameOf } from "@servicestack/client";

import ServiceStackClientContext from "../../contexts/api/ServiceStackContext";


const SwrClient = {
    get: <T>(fn?: () => IReturn<T> | string, configuration?: SWRConfiguration | undefined, fetcherFn?: (client: JsonServiceClient, request: string | IReturn<T> | null) => Promise<T> | null) => {
        const client = useContext(ServiceStackClientContext);

        const request = useMemo(() => {
            if (!fn) {
                return null;
            }

            return fn();

        }, [fn])

        const key = useMemo(() => {
            if (!request) {
                return null;
            }

            return appendQueryString(`SwrClient:${nameOf(request)}`, request);

        }, [request])

        const fetcher = useCallback((_: string) => {
            if (fetcherFn) {
                return fetcherFn(client, request);
            }

            if (!request) {
                return null;
            }

            return client.get(request);

        }, [request, fetcherFn, client])

        return useSWR(key, fetcher, configuration) as SWRResponse<T, T>;
    },
    post: <T>(fn?: () => IReturn<T>, configuration?: SWRConfiguration | undefined, fetcherFn?: (client: JsonServiceClient, request: IReturn<T> | null) => Promise<T> | null) => {
        const client = useContext(ServiceStackClientContext);

        const request = useMemo(() => {
            if (!fn) {
                return null;
            }

            return fn();
        }, [fn])
        
        const key = useMemo(() => {
            if (!request) {
                return null;
            }

            return appendQueryString(`SwrClient:${nameOf(request)}`, request);
        }, [request]);

        const fetcher = useCallback((_: string) => {
            if (fetcherFn) {
                return fetcherFn(client, request);
            }

            if (!request) { 
                return null 
            }

            return client.post(request) 
        }, [request, fetcherFn, client])

        return useSWR(key, fetcher, configuration) as SWRResponse<T, T>
    }
}

const useSwrClient = () => {
    return SwrClient;
}

export default useSwrClient;